import { useMutation } from "@apollo/client"
import { TOURNAMENT_MATCH_CREATE } from "../queries/tournamentMatchCreate"

interface TournamentMatchCreateInput {
  tournamentId: number
  roundId: number
  table: number
  playerId?: number
  opponentId?: number
}

export const useTournamentMatchCreate = () => {
  const [tournamentMatchCreateMutation, { loading, error }] = useMutation(TOURNAMENT_MATCH_CREATE)

  const tournamentMatchCreate = async (input: TournamentMatchCreateInput) => {
    try {
      const { data } = await tournamentMatchCreateMutation({
        variables: { TournamentMatchCreateInput: input },
      })
      return data?.TournamentMatchCreate
    } catch (mutationError) {
      console.error("Error creating tournament match:", mutationError)
      throw mutationError
    }
  }

  return {
    tournamentMatchCreate,
    loading,
    error,
  }
}
